import React from 'react'
import SearchBar from "@/components/SearchBar"


export default function Section() {

  return (
    <section className="relative grid gap-8" >
      <div className="z-20 flex max-w-[980px] flex-col items-start gap-2">
        <h1 className='text-[37px] font-semibold leading-tight tracking-tight md:text-[37px] crimison-pro'>
        How long to read a book
        </h1>


        <p className="max-w-[700px] text-lg text-muted-foreground"
          style={{ color: '#78716c' }}
        >
          Quickly estimate the time required to read your next book.
        </p>
      </div>
      <div className='search'>
        <SearchBar />
      </div>
      <div className="mt-12" >

      </div>
    </section>
  )
}


